/** Help §5.13 — Clients (`contacts/ClientsView.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, HelpSectionCard, Li, P, Shot, Steps, SubHead } from '../HelpPrimitives.js';

export function Clients(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('clients')}>
      <P>
        Click <Btn>Clients</Btn> in the sidebar to see your client and contact directory, with the
        projects each contact is linked to.
      </P>
      <Shot
        slug="clients"
        caption="The Clients directory — companies and contacts with the projects they belong to."
      />
      <SubHead>Directory</SubHead>
      <P>
        The <Btn>Directory</Btn> tab lists every client. Open one to see its details (
        <Btn>Edit</Btn> / <Btn>Delete</Btn>) and its contacts — add a new contact right there with
        the <Btn>Name</Btn> / <Btn>Email</Btn> / <Btn>Position</Btn> fields and the <Btn>Add</Btn>{' '}
        button at the bottom of the list.
      </P>

      <SubHead>Duplicates</SubHead>
      <P>
        The <Btn>Duplicates</Btn> tab finds likely duplicate clients or contacts and groups them.
      </P>
      <Steps>
        <Li>Pick which record should survive (the radio button next to it).</Li>
        <Li>
          Click <Btn>Preview</Btn> to see what the merge would do — how many projects get relinked,
          how many contacts move over, which fields get filled in — without changing anything yet.
        </Li>
        <Li>
          Click <Btn>Merge</Btn> to confirm.
        </Li>
      </Steps>
      <P>Nothing is combined until you explicitly confirm the preview.</P>
    </HelpSectionCard>
  );
}
